var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-clr1",attrs:{"id":"napp"}},[_c('div',{attrs:{"id":"top"}},[_c('nav',[_c('defmenu',{attrs:{"user":_vm.user}})],1),_c('header')]),_c('router-view',{attrs:{"id":"view"}}),_c('deffooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }